<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div ref="txtRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
        <textarea v-model="txtRemarks" no="txtRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { getVolumeWeightRatioCode } from '@/class/cargo/model/parameters/VolumeWeightRatio'

export default {
  name: 'LclExportRemarkDataGrid',
  components: {},
  props: {
    configModule: { type: String, default: '224600' },
    showPriceNo: { type: Boolean, default: true },
    showApprove: { type: Boolean, default: false },
    showCurrency: { type: Boolean, default: false },
    showCreate: { type: Boolean, default: false },
    showModify: { type: Boolean, default: false },
    showSelection: { type: Boolean, default: false },
    showHistory: { type: Boolean, default: false },
    view: { type: Number, default: 4 },
    filter: { type: Object, default: () => {} },
    gridOptions: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      URL,
      showLevel: false, // 是否显示运价等级
      txtRemarks: '',
      remarkChange: false,
      authedLevel: 99,
      proxy: {},
      filterJson: {},
      showDetail: false,
      fullscreenLoading: false,
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200,
          hide: !this.showPriceNo, suppressColumnsToolPanel: !this.showPriceNo
        },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          } },
        {
          headerName: this.$t('Pricing.Direct'), field: 'direct', colId: 'direct', width: 70,
          valueFormatter: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        { headerName: this.$t('Pricing.PriceState'), field: 'priceState', colId: 'priceState', width: 70,
          valueFormatter: (params) => {
            return PriceUtils.priceStateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.PriceTrend'), field: 'trend', colId: 'trend', width: 80,
          valueFormatter: (params) => {
            return PriceUtils.trendLabelFunc(params.value)
          } },
        {
          headerName: this.$t('Pricing.CabinNature'), field: 'share', colId: 'share', width: 80,
          valueFormatter: (params) => {
            return PriceUtils.shareColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.carrierLabFunc(params.data, params.value)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.carrierTipFunc(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.ContractNo'), field: 'contractNo', colId: 'contractNo', width: 60
        },
        { headerName: this.$t('Pricing.Source'), field: 'bookingAgent', colId: 'bookingAgent', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.bookingAgentLabelFunc(params.data, params.value, this.tenantUtil)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company,
              'cmpIdx', params.value, this.language)
          }
        },
        {
          headerName: this.$t('Pricing.RateGrade'), field: 'gradeMin', colId: 'gradeMin', width: 70,
          valueFormatter: (params) => {
            return PriceUtils.gradeMinLabelFunc(params)
          }
        },
        {
          headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200,
          hide: !this.showCurrency, suppressColumnsToolPanel: !this.showCurrency
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(TON)', field: 'costWeightPrice', colId: 'costWeightPrice', width: 85,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(CBM)', field: 'costVolumePrice', colId: 'costVolumePrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(MIN)', field: 'minimumTonCost', colId: 'minimumTonCost', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(TON)', field: 'oneWeightPrice', colId: 'oneWeightPrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(CBM)', field: 'oneVolumePrice', colId: 'oneVolumePrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(MIN)', field: 'minimumTonPrice1', colId: 'minimumTonPrice1', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(TON)', field: 'twoWeightPrice', colId: 'twoWeightPrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(CBM)', field: 'twoVolumePrice', colId: 'twoVolumePrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(MIN)', field: 'minimumTonPrice2', colId: 'minimumTonPrice2', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(TON)', field: 'threeWeightPrice', colId: 'threeWeightPrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(CBM)', field: 'threeVolumePrice', colId: 'threeVolumePrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(MIN)', field: 'minimumTonPrice3', colId: 'minimumTonPrice3', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.COST_VAT'), field: 'costVat', colId: 'costVat', width: 200
        },
        {
          headerName: this.$t('Pricing.SELL_VAT'), field: 'sellVat', colId: 'sellVat', width: 200
        },
        {
          headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.dataGridColumnPaymentFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.ShippingLine'), field: 'shippingLine', colId: 'shippingLine', width: 200 },
        { headerName: this.$t('Pricing.DepartureDay'), field: 'frequency8', colId: 'frequency8', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.frequencyLabelFunc(params.data, 'frequency')
          } },
        {
          headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200
        },
        {
          headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200
        },
        {
          headerName: this.$t('Pricing.ShareCarriers'), field: 'shareCarrier', colId: 'shareCarrier', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.moreCompanyLabelFun(params.value, 'shortName', 'cmpIdx')
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.shareCarrierTipFunc(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.DestinationDock'), field: 'destinationDock', colId: 'destinationDock', width: 200
        },
        {
          headerName: this.$t('Pricing.TransportMode'), field: 'transportMode', colId: 'transportMode', width: 200
        },
        {
          headerName: this.$t('Pricing.SubContractNo'), field: 'subContractNo', colId: 'subContractNo', width: 200
        },
        {
          headerName: this.$t('Pricing.NA'), field: 'na', colId: 'na', width: 200
        },
        {
          headerName: this.$t('Pricing.NaCode'), field: 'naCode', colId: 'naCode', width: 200
        },
        { headerName: this.$t('Pricing.customSpecs'), field: 'customSpecs', colId: 'customSpecs', width: 200 },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.remarkLabelFunc(params.data, params.value)
          }
        },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          } },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedBy'), field: 'approvedBy', colId: 'approvedBy', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateApproved', colId: 'dateApproved', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.ROD'), field: 'region', colId: 'region', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.regionForPriceFclLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.regionForPriceFclLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.volumeWeightRatio'),
          field: 'volumeWeightRatio',
          colId: 'volumeWeightRatio',
          width: 200,
          valueFormatter: params => getVolumeWeightRatioCode(params.value)['name']
        },
        {
          headerName: this.$t('Pricing.minRateValue'),
          field: 'minRateUnit',
          colId: 'minRateUnit',
          width: 200,
          valueFormatter(params) {
            if (params.data.minRateUnit === '最低价') {
              return params.data.minRateUnit
            } else {
              return (params.data.minRateValue || 0) + '' + params.data.minRateUnit
            }
          }
        },
        // 目的港代理
        {
          headerName: this.$t('Pricing.DestinationAgent'),
          field: 'destinationAgent',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.moreCompanyLabelFun(params.value, 'englishName', 'cmpIdx')
          }
        },
        // 仓库
        {
          headerName: this.$t('Pricing.warehouse'),
          field: 'warehouseVendorCmpIdx',
          width: 200,
          valueFormatter: (params) => {
            const name = this.$i18n.locale === 'zh' ? 'chineseName' : 'englishName'
            return ColumnUtils.moreCompanyLabelFun(params.value + '', name, 'cmpIdx')
          }
        },
        // 仓库名称
        {
          headerName: this.$t('Pricing.WarehouseName'),
          field: 'warehouseName',
          width: 200
        },
        // 仓库地址
        {
          headerName: this.$t('Pricing.WarehouseAddress'),
          field: 'warehouseAddress',
          width: 200
        },
        // 仓库联系人
        {
          headerName: this.$t('Pricing.warehouseContact'),
          field: 'warehouseContact',
          width: 200
        },
        // 仓库地图
        {
          headerName: this.$t('Pricing.WarehouseMap'),
          field: 'mapFile',
          width: 200,
          cellRenderer: params => {
            if (!params.value) {
              return ''
            }
            return `<img src="data:image/jpeg;base64,${params.value}" fit="fill" style="height:25px;" >`
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
    rowData() {
      this.txtRemarks = ''
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.gridOptions.onRowClicked = this.onRowClickedEvent
      this.authedLevel = this.getAuthedLevel()
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PFDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PFDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PFDA_*_2'])) {
        return 2
      }
      return 99
    },
    setBooleanValue(field) {
      if (this.filter[field]) {
        this.proxy[field] = this.filter[field]
      }
    },
    onTxtRemarksDoubleClick() {
      console.log('txtRemarks', this.$refs.txtRemark)
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.$emit('selectRowChange', data) // 行选中回调
      this.txtRemarks = data.remarks
    }
  }
}
</script>
<style lang="scss">
</style>

